import React, { useMemo } from 'react';
import { Avatar, AvatarProps as FlowBiteAvatarProps } from 'flowbite-react';
import { avatarTheme } from '../../styles/themes/avatar';
import './avatar.sass';
import clsx from 'clsx';

export interface AvatarProps {
    rounded?: boolean;
    size?: FlowBiteAvatarProps['size'];
    imgURL?: string;
    testId?: string;
    initials?: string;
    userStatus?: FlowBiteAvatarProps['status'];
    avatarText?: React.ReactElement;
    stacked?: FlowBiteAvatarProps['stacked'];
    key?: string;
}

const textSizeMapping: Record<string, string> = {
    xs: 'text-label-medium',
    sm: 'text-title-small',
    md: 'text-title-medium',
    lg: 'text-title-large',
    xl: 'text-display-medium',
};

const sizeClassMapping: Record<string, string> = {
    xs: 'avatar-xs',
    sm: 'avatar-sm',
    md: 'avatar-md',
    lg: 'avatar-lg',
    xl: 'avatar-xl',
};

export const AvatarComponent: React.FC<AvatarProps> = ({
    rounded = false,
    size = 'lg',
    imgURL = '',
    testId,
    initials = '',
    userStatus,
    avatarText,
    stacked = false,
    key,
}) => {
    const userStatusPosition = userStatus ? 'top-right' : undefined;

    const customTheme = useMemo(() => {
        return {
            ...avatarTheme,
            root: {
                ...avatarTheme?.root,
                initials: {
                    ...avatarTheme?.root?.initials,
                    text: clsx(avatarTheme?.root?.initials?.text, textSizeMapping[size]),
                },
            },
        };
    }, [size]);

    const containerClassName = sizeClassMapping[size] || '';

    return (
        <div data-testid={testId}>
            <Avatar
                key={key}
                rounded={rounded}
                size={size}
                img={imgURL}
                placeholderInitials={initials}
                status={userStatus}
                statusPosition={userStatusPosition}
                theme={customTheme}
                stacked={stacked}
                className={containerClassName}
            >
                {avatarText}
            </Avatar>
        </div>
    );
};
